module.exports = __webpack_public_path__ + "assets/img/icon2-menu.cf62138b.svg";